import serverAction from "~/serverAction"
import {HTTPMethod} from "~/providers/new/httpMethod"
import {RouteHelper} from "~/helpers/routeHelper"
import {Route} from "~/enums/route"
import {IResponse} from "~/interfaces/serverInterfaces"
import {Hash} from "~/interfaces/hashInterfaces"

export default class ProcessFlowSubmissionProvider {
  resume(submissionId: string, json): Promise<any> {
    return serverAction<IResponse>({
      endpoint: RouteHelper.path({
        route: Route.resumeProcessFlowSubmission,
        modelOrId: submissionId,
      }),
      method: HTTPMethod.PUT,
      json: json,
    })
  }

  paused(submissionId: string): Promise<any> {
    return serverAction<IResponse>({
      endpoint: RouteHelper.path({
        route: Route.processFlowSubmissionPaused,
        modelOrId: submissionId,
      }),
      method: HTTPMethod.GET,
    })
  }

  executeDebug(processFlowId: string, json: { input_variables: Hash, debug: boolean }) {
    return serverAction<IResponse>({
      endpoint: RouteHelper.path({
        route: Route.executeDebugProcessFlow,
        modelOrId: processFlowId,
      }),
      method: HTTPMethod.POST,
      json: json,
    })
  }
}